import React, { Component } from 'react';
import Alert from '@material-ui/lab/Alert';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import TrashIcon from 'material-ui/svg-icons/action/delete';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import PublishIcon from '@material-ui/icons/Publish';
import ConfirmIcon from 'material-ui/svg-icons/navigation/check';
import CursorPointer from '../../../icons/CursorPointer';
import Polygon from '../../../icons/Polygon';
import FormControl from '@material-ui/core/FormControl';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';

import theme from '../../../muiTheme';

const activeStyle = {
    color: theme.palette.primary1Color
}
const paperStyle = {
    borderRadius: "0 0 2px 2px"
}

class EditPerimeterToolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTool: "POLYGON", // null (cursor), POLYGON
            isUploading: false,
            showShapeParseError: false
        };
    }

    inputFileChanged = async (e) =>
    {
      if (window.FileReader)
      {
        this.setState({
          isUploading: true
        });
      }

    let file = e.target.files && e.target.files.length >0 ? e.target.files[0] : null;
    this.generateFeatureCollection(file);
    this.refs.input_reader.value = null;
  }

  generateFeatureCollection = (file) =>
  {
    var params = {
      name: file,
      targetSR: new SpatialReference(4269),
      maxRecordCount: 1000,
      enforceInputFileSizeLimit: true,
      enforceOutputJsonSizeLimit: true
    };

    // generalize features to 10 meters for better performance
    //TODO: These are being overwritten by the API call
    params.generalize = false;
    params.maxAllowableOffset = 5;
    params.reducePrecision = false;
    //params.numberOfDigitsAfterDecimal = 0;

    window.api.generateFeatureFromShapefile(params, file).then(perimeter =>
      {
        if (perimeter)
        {
            this.props.onUploadPerimeter(perimeter);
        }
      }
    ).catch(err =>
      {
        this.setState({showShapeParseError: true});
      });

    }

    uploadShapefile = () =>
    {
        let input = this.refs.input_reader;
        input.click();
    }

    closeSnackbar = () => {
      this.setState({showShapeParseError: false})
    }

    setTool = (activeTool) =>
    {
        this.setState({ activeTool });
    }


    render() {
        const uploadAlert = (this.state.showShapeParseError) ? (<Alert severity="warning">Note: Unable to parse shapefile or found empty geometry. Please verify .zip contents and geometry and try again.</Alert>) : "";
        return (
            <Paper className="edit-geometry-container edit-perimeter-container" zDepth={2} style={paperStyle}>
            <FormControl>
              <input type="file" ref="input_reader" accept=".zip" multiple={false} style={{display:'none'}} onChange={this.inputFileChanged}/>
                <div className="edit-perimeter-tools">
                    <IconButton
                        iconStyle={(this.state.activeTool === null ? activeStyle : {})}
                        tooltip="Cursor"
                        onClick={() => { this.setTool(null); this.props.onDeactivate(); this.setState({showShapeParseError: false}); }} >
                        <CursorPointer />
                    </IconButton>

                    <IconButton
                        iconStyle={(this.state.activeTool === "POLYGON" ? activeStyle : {})}
                        tooltip="Freehand Polygon"
                        onClick={() => { this.setTool("POLYGON"); this.props.onActivate(); this.setState({showShapeParseError: false}); }} >
                        <Polygon />
                    </IconButton>

                    <IconButton
                        tooltip="Upload"
                        onClick={() => { this.uploadShapefile(); this.props.onDeactivate(); this.setState({showShapeParseError: false}); }} >
                        <PublishIcon />
                    </IconButton>

                <IconButton tooltip="Delete Perimeter" onClick={this.props.onClearPerimeter}>
                    <TrashIcon />
                </IconButton>

                    <IconButton tooltip="Cancel Perimeter Editing" onClick={this.props.onCancelPerimeterEdit}>
                        <CloseIcon />
                    </IconButton>

                    <IconButton tooltip="Confirm Perimeter" onClick={this.props.onConfirmPerimeterEdit} disabled={this.props.confirmDisabled}>
                        <ConfirmIcon />
                    </IconButton>
                  </div>

                </FormControl>
                {uploadAlert}
            </Paper>
        )
    }
}

export default EditPerimeterToolbar;
